import moment from 'moment';

export const userStatus = [
    { key: '1', value: '使用中' },
    { key: '0', value: '已停用' },
];

export const invoiceDatePeriod = [
    { key: null, value: '不限日期' },
    { key: '0', value: '本年度' },
    { key: '1', value: '去年度' },
    { key: '2', value: '自訂日期' },
];

export const invoiceType = [
    { key: null, value: '不限類型' },
    { key: 2, value: '二聯式' },
    { key: 3, value: '三聯式' },
    { key: 4, value: '核銷' },
    { key: 1, value: 'INVOICE' },
];

export const invoiceStatus = [
    { key: 0, value: '待審核', name: 'pending' },
    { key: 1, value: '待開立', name: 'wait-for-pay' },
    { key: 2, value: '待入帳', name: 'to-be-pass' },
    { key: 3, value: '完成', name: 'done' },
    { key: 4, value: '退件', name: 'reject' },
    { key: 5, value: '撤銷', name: 'cancel' },
];

export const discountType = [
    { key: 1, value: '部份折讓' },
    { key: 2, value: '全額退回' },
];

export const monthOptions = [
    { key: 1, value: '1月' },
    { key: 2, value: '2月' },
    { key: 3, value: '3月' },
    { key: 4, value: '4月' },
    { key: 5, value: '5月' },
    { key: 6, value: '6月' },
    { key: 7, value: '7月' },
    { key: 8, value: '8月' },
    { key: 9, value: '9月' },
    { key: 10, value: '10月' },
    { key: 11, value: '11月' },
    { key: 12, value: '12月' },
];

export const paymentType = [
    { key: null, value: '不限類型', intro: '' },
    {
        key: 1,
        value: '一般請款',
        formName: '一般請款單',
        icon: 'goods',
        intro: '一般支出、行政管理費用',
    },
    {
        key: 2,
        value: '專案請款',
        formName: '專案請款單',
        icon: 'data-line',
        intro: '業務外包、專案委外之各項費用',
    },
    {
        key: 3,
        value: '特定費請款',
        formName: '特定費請款單',
        icon: 'office-building',
        intro: '有預算的特定支出，例：購置資產設備、辦公室裝潢',
    },
    {
        key: 4,
        value: '經常性費用',
        formName: '經常性費用請款單',
        icon: 'milk-tea',
        intro: '例行性小額費用, 如清潔、開會點心',
    },
    {
        key: 5,
        value: '國際匯款',
        formName: '國際匯款請款單',
        icon: 'position',
        intro: '領台幣做臨櫃外幣匯款',
    },
    {
        key: 6,
        value: '財務單',
        formName: '財務單',
        icon: 'postcard',
        intro: '繳費單、銀行自動扣款專用，無需審核',
        tip: '限有付款作業權限人員使用',
    },
];

export const paymentStatus = [
    { key: 1, value: '待審核', name: 'pending' },
    { key: 2, value: '待確認付款', name: 'wait-for-confirm' },
    { key: 3, value: '完成', name: 'done' },
    { key: 4, value: '退件', name: 'reject' },
    { key: 5, value: '待付款', name: 'wait-for-pay' },
];

export const paymentAuditStepName = [
    { key: 'A02', value: '付款' },
    { key: 'A03', value: '確認付款' },
    { key: '主管', value: '主管審核' },
];

export const statementTypes = [
    { key: 'invoiceSettings', value: '營業收入', type: 3 },
    { key: 'payoutSettings', value: '營業支出', type: 4 },
    { key: 'cInSettings', value: '營業其他收入', type: 1 },
    { key: 'cOutSettings', value: '營業其他支出', type: 2 },
    { key: 'cInElseSettings', value: '財務資產收入', type: 5 },
    { key: 'cOutElseSettings', value: '財務資產支出', type: 6 },
];

export const cnyName = {
    TWD: '新台幣',
    USD: '美金',
    HKD: '港幣',
    AUD: '澳幣',
    JPY: '日圓',
    EUR: '歐元',
    CNY: '人民幣',
    GBP: '英鎊',
    CAD: '加幣',
};

export const accountingSettingGroup = [
    { id: 1, key: 'assetsSettings', value: '資產' },
    { id: 2, key: 'liabilitiesSettings', value: '負債' },
    { id: 3, key: 'shareholderSettings', value: '股東權益' },
    { id: 4, key: 'revSettings', value: '營業收入' },
    { id: 5, key: 'costSettings', value: '營業成本' },
    { id: 6, key: 'oeSettings', value: '營業費用' },
    { id: 7, key: 'norSettings', value: '營業外收入' },
    { id: 8, key: 'noeSettings', value: '營業外支出' },
    { id: 9, key: 'taxSettings', value: '所得稅費用' },
];

export const financeStatementList = [
    { id: 1, value: '資金與投資' },
    { id: 2, value: '融資' },
    { id: 3, value: '其他流動' },
    { id: 4, value: '台外幣互轉' },
    { id: 5, value: '帳戶內部互轉' },
];

export const incomeStateSheetItems = [
    { key: 'revSettings', value: '營業收入', id: 4 },
    { key: 'costSettings', value: '營業成本', id: 5 },
    { key: 'oeSettings', value: '營業費用', id: 6 },
    { key: 'norSettings', value: '其他收入', id: 7 },
    { key: 'noeSettings', value: '其他費用', id: 8 },
    { key: 'taxSettings', value: '所得稅費用', id: 9 },
];

export const attachmentTypes = [
    { key: 1, value: '電子發票', declareTax: true },
    { key: 2, value: '二聯式發票（收銀機統一發票）', declareTax: true },
    { key: 3, value: '三聯式發票（手開）', declareTax: true },
    { key: 10, value: '三聯式發票（收銀機）', declareTax: true },
    { key: 4, value: '一般收據' },
    { key: 11, value: '載有稅額之其他憑證（高鐵、台鐵...）', declareTax: true },
    { key: 5, value: '合約' },
    { key: 6, value: '勞務單' },
    { key: 7, value: '其他證明' },
];

export const datePickerOption = {
    shortcuts: [
        {
            text: `明年 - ${moment().year() + 1}`,
            onClick(picker) {
                const thisYear = moment().year(moment().year() + 1);
                const sd = Number(
                    moment(thisYear)
                        .startOf('year')
                        .format('x'),
                );
                const ed = Number(
                    moment(thisYear)
                        .endOf('year')
                        .format('x'),
                );

                picker.$emit('pick', [sd, ed]);
            },
        },
        {
            text: `今年 - ${moment().year()}`,
            onClick(picker) {
                const sd = Number(
                    moment()
                        .startOf('year')
                        .format('x'),
                );
                const ed = Number(
                    moment()
                        .endOf('year')
                        .format('x'),
                );

                picker.$emit('pick', [sd, ed]);
            },
        },
        {
            text: `去年 - ${moment().year() - 1}`,
            onClick(picker) {
                const thisYear = moment().year(moment().year() - 1);
                const sd = Number(
                    moment(thisYear)
                        .startOf('year')
                        .format('x'),
                );
                const ed = Number(
                    moment(thisYear)
                        .endOf('year')
                        .format('x'),
                );

                picker.$emit('pick', [sd, ed]);
            },
        },
        {
            text: `下月 - ${moment().month() >= 11 ? 1 : moment().month() + 2}月`,
            onClick(picker) {
                const sd = Number(
                    moment()
                        .add(1, 'months')
                        .startOf('month')
                        .format('x'),
                );
                const ed = Number(
                    moment()
                        .add(1, 'months')
                        .endOf('month')
                        .format('x'),
                );

                picker.$emit('pick', [sd, ed]);
            },
        },
        {
            text: `本月 - ${moment().month() + 1}月`,
            onClick(picker) {
                const sd = Number(
                    moment()
                        .startOf('month')
                        .format('x'),
                );
                const ed = Number(
                    moment()
                        .endOf('month')
                        .format('x'),
                );

                picker.$emit('pick', [sd, ed]);
            },
        },
        {
            text: `上月 - ${moment().month() || 12}月`,
            onClick(picker) {
                const sd = Number(
                    moment()
                        .subtract(1, 'months')
                        .startOf('month')
                        .format('x'),
                );
                const ed = Number(
                    moment()
                        .subtract(1, 'months')
                        .endOf('month')
                        .format('x'),
                );

                picker.$emit('pick', [sd, ed]);
            },
        },
        {
            text: '本週',
            onClick(picker) {
                const sd = Number(
                    moment()
                        .startOf('week')
                        .format('x'),
                );
                const ed = Number(
                    moment()
                        .endOf('week')
                        .format('x'),
                );

                picker.$emit('pick', [sd, ed]);
            },
        },
        {
            text: '不限',
            onClick(picker) {
                picker.$emit('pick', []);
            },
        },
    ],
};

export const PettyCashLabelOptions = [
    {
        typ: 1,
        label: '轉入',
        QueryTabNo: 2,
        class: 'import',
        fieldName: 'transferInCount',
    },
    {
        typ: 2,
        label: '轉出',
        QueryTabNo: 3,
        class: 'export',
        fieldName: 'transferOutCount',
    },
    {
        typ: 3,
        label: '發票入帳',
        QueryTabNo: 5,
        class: 'arrival',
        fieldName: 'invoiceTransferInCount',
    },
    {
        typ: 4,
        label: '發票退款',
        QueryTabNo: 6,
        class: 'refund',
        fieldName: 'invoiceTransferOutCount',
    },
    {
        typ: 999,
        label: '請款單轉出',
        QueryTabNo: 4,
        class: 'export-payment',
        fieldName: 'paymentTransferOutCount',
    },
    {
        typ: 5,
        label: '人事費用轉出',
        QueryTabNo: 7,
        class: 'personnel-fee-payment',
        fieldName: 'staffCostTransferOutCount',
    },
    {
        typ: 6,
        label: '薪資轉出',
        QueryTabNo: 8,
        class: 'salary-payment',
        fieldName: 'salaryTransferOutCount',
    },
];

export const projectContractTypeOptions = [
    { value: 1, label: '合約' },
    { value: 2, label: '報價單' },
    { value: 3, label: '其他' },
];

export const serviceTypeList = [
    {
        value: 1,
        type: '9A',
        label: '9A 執行業務所得',
        healthInsuranceCode: '65',
        note: '稅額超過 2,000 才扣 10%',
        notes: {
            residentTax: '達到 20,010 元，代扣 10%',
            nonresidentTax: '無論金額多寡，代扣 20%',
            gen2: '達到 20,000 元，代扣 2.11%',
        },
    },
    {
        value: 2,
        type: '9B',
        label: '9B 稿費、顧問費、演講費、出席費',
        healthInsuranceCode: '65',
        note: '稅額超過 2,000 才扣 10%',
        notes: {
            residentTax: '達到 20,010 元，代扣 10%',
            nonresidentTax: '超過 5,000 元，代扣 20%',
            gen2: '達到 20,000 元，代扣 2.11%',
        },
    },
    {
        value: 3,
        type: '50',
        label: '50 薪資所得（兼職）',
        healthInsuranceCode: '',
        note: '給付金額達到 90,501 要扣 5%',
        notes: {
            residentTax: '達到 90,501 元，代扣 5%',
            nonresidentTax: '基本工資（29,500 元）的 1.5 倍以下，代扣 6%。超過基本工資 1.5 倍，代扣 18%。',
            gen2: '達到基本工資（29,500 元），代扣 2.11%',
        },
    },
    {
        value: 4,
        type: '51',
        label: '51 租金收入',
        healthInsuranceCode: '68',
        note: '稅額超過 2,000 才扣 10%',
        notes: {
            residentTax: '達到 20,010 元，代扣 10%',
            nonresidentTax: '無論金額多寡，代扣 20%',
            gen2: '達到 20,000 元，代扣 2.11%',
        },
    },
    {
        value: 6,
        type: '53',
        label: '53 權利金',
        healthInsuranceCode: '',
        note: '稅額超過 2,000 才扣 10%',
        notes: {
            residentTax: '達到 20,010 元，代扣 10%',
            nonresidentTax: '無論金額多寡，代扣 20%',
            gen2: '免扣',
        },
    },
    {
        value: 5,
        type: '91',
        label: '91 競技、競賽及機會中獎之獎金',
        healthInsuranceCode: '',
        note: '稅額超過 2,000 才扣 10%',
        notes: {
            residentTax: '達到 20,010 元，代扣 10%',
            nonresidentTax: '無論金額多寡，代扣 20%',
            gen2: '免扣',
        },
    },
    {
        value: 0,
        type: '其他',
        label: '其他',
        healthInsuranceCode: '',
        note: '無',
        notes: {
            residentTax: '免扣',
            nonresidentTax: '免扣',
            gen2: '免扣',
        },
    },
];

export const TAX_AMT_THRESHOLD = 2000;
export const MINIMUM_WAGE = 29500;

export const eInvoicePlatformInfo = {
    ezPay: {
        label: 'ezPay',
        href: 'https://inv.ezpay.com.tw/main/Login_center/single_login',
    },
    sunPay: {
        label: '紅陽',
        href: 'https://inv.sunpay.com.tw/',
    },
    none: {
        label: '--',
        href: '',
    },
};

export const PAY_WAY_LIST = [
    {
        label: '零用現金',
        value: 1,
    },
    {
        label: '銀行轉帳',
        value: 2,
    },
    {
        label: '銀行提現',
        value: 3,
    },
];

export const paymentPayWay = [
    { key: 1, label: '零用現金' },
    { key: 2, label: '銀行轉帳' },
    { key: 3, label: '銀行提現' },
];

export const paymentPayToType = [
    { key: 1, label: '公司員工' },
    { key: 2, label: '委外廠商' },
    { key: 3, label: '委外勞務' },
];

export const abdType = [
    { key: 0, label: '政府' },
    { key: 1, label: '公營事業' },
    { key: 2, label: '民間' },
];

export const gaapList = [
    { value: 1, label: '流動資產' },
    { value: 2, label: '非流動資產' },
    { value: 3, label: '流動負債' },
    { value: 4, label: '非流動負債' },
    { value: 5, label: '股東權益' },
    { value: 6, label: '本期損益' },
];

export const voucherType = [
    { key: 1, name: 'Invoice', label: '發票收入' },
    { key: 2, name: 'Payment', label: '請款支出' },
    { key: 3, name: 'IncomeStatement', label: '財務收支' },
    { key: 4, name: 'Salary', label: '薪資支出' },
    { key: 5, name: 'TranInvoice', label: '核銷轉開發票' },
    { key: 6, name: 'LoanReceiptDrawdown', label: '借款動撥' },
    { key: 7, name: 'LoanReceiptRepayment', label: '借款還款' },
    { key: 8, name: 'TRANSFER', label: '存款帳戶互轉' },
    { key: 9, name: 'PettyCash', label: '零用金' },
    { key: 10, name: 'Blank', label: '空白' },
    { key: 99, name: 'Year', label: '年度結束算' },
];

export const transactionType = [
    { key: 1, name: 'Invoice', label: '發票收入' },
    { key: 2, name: 'Payment', label: '請款支出' },
    { key: 3, name: 'IncomeStatementIn', label: '營業其他收入' },
    { key: 4, name: 'IncomeStatementOut', label: '營業其他支出' },
    { key: 5, name: 'IncomeAssetsIn', label: '財務資產收入' },
    { key: 6, name: 'IncomeAssetsOut', label: '財務資產支出' },
    { key: 7, name: 'Salary', label: '薪資支出' },
    { key: 8, name: 'LoanReceipt', label: '借款管理' },
    { key: 9, name: 'TRANSFER', label: '存款帳戶互轉' },
    { key: 10, name: 'PettyCash', label: '零用金' },
    { key: 11, name: 'Blank', label: '自編傳票' },
    { key: 12, name: 'Inital', label: '開帳' },
    { key: 13, name: 'Forward', label: '結帳' },
    { key: 14, name: '', label: '所得稅' },
    { key: 15, name: '', label: '調整' },
];

export const accountingStatusOptions = [
    {
        key: 0,
        name: 'wait-for-check',
        label: '待檢核',
        fullLabel: '待檢核',
        description: '交易或傳票作業尚未完成',
        icon: 'el-icon-time',
    },
    {
        key: 1,
        name: 'complete',
        label: '完成',
        fullLabel: '財會檢核完成',
        condition: true,
        description: '交易及傳票作業已完成',
        icon: 'el-icon-check',
    },
    {
        key: 2,
        name: 'no-accounting-need',
        label: '不作帳',
        fullLabel: '不作帳',
        description: null,
        icon: 'el-icon-close',
    },
];

export const applicationFormTypOptions = [
    { key: 1, label: '營業稅' },
    { key: 2, label: '代扣稅款' },
    { key: 3, label: '營利所得稅' },
    { key: 4, label: '年度所得扣繳' },
    { key: 5, label: '代扣二代健保' },
    { key: 6, label: '年度健保' },
    { key: 7, label: '其他' },
];

export const serviceFeeStatementType = [
    {
        key: 1,
        value: '公司填寫',
        intro: '申請人需填寫全部內容',
    },
    {
        key: 2,
        value: '領款人填寫',
        intro: '申請人填寫部分內容後，發給領款人完成填寫、並於付款後簽收。',
    },
];

export const serviceType9AList = [
    { key: 10, value: 'Lawyer', label: '律師' },
    { key: 11, value: 'Accountant', label: '會計師' },
    { key: 12, value: 'Actuary', label: '精算師' },
    { key: 13, value: 'LandRegistrar', label: '地政士' },
    { key: 14, value: 'Bookkeeper', label: '記帳士' },
    { key: 15, value: 'Arbitrator', label: '仲裁人' },
    { key: 16, value: 'NotaryPublic', label: '民間公證人' },
    { key: 17, value: 'RealEstateAppraiser', label: '不動產估價師' },
    { key: 18, value: 'AuthorizedLandAgent', label: '受委託代辦國有非公用不動產相關申請者' },
    { key: 19, value: 'TaxAgent', label: '記帳及報稅代理人' },
    { key: 20, value: 'Technician', label: '技師' },
    { key: 21, value: 'Architect', label: '建築師' },
    { key: 22, value: 'PublicSafetyInspector', label: '公共安檢人員' },
    { key: 23, value: 'BusinessRegistrationAgent', label: '未具會計師資格辦理工商登記等業務者' },
    { key: 24, value: 'CraftsmanWages', label: '工匠(工資收入)' },
    { key: 25, value: 'CraftsmanMaterials', label: '工匠(工料收入)' },
    { key: 26, value: 'Pilot', label: '引水人' },
    { key: 27, value: 'LegalAidLawyer', label: '法律扶助案件律師收入' },
    { key: 28, value: 'ArtistWages', label: '美術工藝家(工資收入)' },
    { key: 29, value: 'ArtistMaterials', label: '美術工藝家(工料收入)' },
    { key: 30, value: 'PhysicianInternalMedicine', label: '內科醫師' },
    { key: 31, value: 'PhysicianSurgery', label: '外科醫師' },
    { key: 32, value: 'PhysicianPediatrics', label: '小兒科醫師' },
    { key: 33, value: 'PhysicianObstetrics', label: '婦產科醫師' },
    { key: 34, value: 'PhysicianOphthalmology', label: '眼科醫師' },
    { key: 35, value: 'PhysicianENT', label: '耳鼻喉科醫師' },
    { key: 36, value: 'Dentist', label: '牙科醫師' },
    { key: 37, value: 'Psychiatrist', label: '精神科醫師' },
    { key: 38, value: 'PhysicianOrthopedics', label: '骨科醫師' },
    { key: 39, value: 'PhysicianOther', label: '其他科別醫師' },
    { key: 40, value: 'Midwife', label: '助產師(士)' },
    { key: 41, value: 'Pharmacist', label: '藥師' },
    { key: 42, value: 'MedicalTechnologist', label: '醫事檢驗師(生)' },
    { key: 45, value: 'Dietitian', label: '營養師' },
    { key: 46, value: 'NonEmployedMedicalPractitioner', label: '無僱傭關係之核准醫師' },
    { key: 47, value: 'Veterinarian', label: '獸醫師' },
    { key: 48, value: 'PhysicianDermatology', label: '皮膚科醫師' },
    { key: 49, value: 'PhysicianFamily', label: '家庭醫學科醫師' },
    { key: 50, value: 'PhysicianChineseMedicine', label: '中醫師' },
    { key: 51, value: 'SpeechTherapist', label: '語言治療師' },
    { key: 52, value: 'LifeInsuranceExaminer', label: '人壽保險醫療檢查' },
    { key: 53, value: 'PhysicalTherapist', label: '物理治療師' },
    { key: 54, value: 'OccupationalTherapist', label: '職能治療師' },
    { key: 55, value: 'Psychologist', label: '心理師' },
    { key: 56, value: 'DentalTechnologist', label: '牙體技術師(生)' },
    { key: 57, value: 'GovernmentSubsidizedServices', label: '補助特定對象服務' },
    { key: 58, value: 'VaccineService', label: '自費疫苗注射收入' },
    { key: 61, value: 'Calligrapher', label: '書畫家、版畫家' },
    { key: 62, value: 'FortuneTeller', label: '命理卜卦' },
    { key: 70, value: 'Performer', label: '表演人' },
    { key: 71, value: 'InsuranceBroker', label: '保險經紀人' },
    { key: 72, value: 'ProgramProducer', label: '節目製作人' },
    { key: 73, value: 'LotteryDistributor', label: '公益彩券甲類經銷商' },
    { key: 76, value: 'GeneralBroker', label: '一般經紀人' },
    { key: 90, value: 'Other', label: '其他' },
    { key: 91, value: 'TrademarkAgent', label: '商標代理人' },
    { key: 92, value: 'Programmer', label: '程式設計師' },
    { key: 93, value: 'PatentAgent', label: '專利師及專利代理人' },
    { key: 94, value: 'UnlicensedLitigationAgent', label: '未具律師資格之訴訟代理人' },
    { key: 95, value: 'UnlicensedArchitect', label: '未具建築師資格之設計及監造者' },
    { key: 96, value: 'UnlicensedLandRegistrar', label: '未具地政士資格之土地登記者' },
    { key: 97, value: 'PRCAgent', label: '受大陸地區人民委託辦理事務者' },
];
export const serviceType9BList = [
    {
        key: 98,
        value: 'NonSelfPublished',
        label: '非自行出版之稿費、版稅、樂譜、作曲、編劇、漫畫及演講之鐘點費等七項',
    },
    {
        key: 99,
        value: 'SelfPublished',
        label: '自行出版之稿費、版稅、作曲、編劇、漫畫',
    },
];

export const serviceFeeStatementStatus = [
    { key: 1, value: '待填寫', name: 'wait-for-fill' },
    { key: 2, value: '待確認', name: 'wait-for-confirm' },
    { key: 3, value: '待請款', name: 'wait-for-pay' },
    { key: 4, value: '請款中', name: 'paying' },
    { key: 5, value: '已付款', name: 'payed' },
    { key: 6, value: '已簽收', name: 'signed' },
    { key: 7, value: '請款退件', name: 'rejected' },
];

export const nationalityList = [
    { key: 0, label: '本國籍' },
    { key: 1, label: '外國籍（在台已滿183天）' },
    { key: 2, label: '外國籍（在台未滿183天）' },
];

export const serviceFeePlannedPayWay = [
    { key: 1, label: '領現金' },
    { key: 2, label: '銀行轉帳' },
];

export const bankAccountType = [
    { key: 1, label: '本國帳戶' },
    { key: 2, label: '外國帳戶' },
];

export const bankAccountDocumentInUseOptions = [
    { key: 1, label: '請款單付款' },
    { key: 2, label: '發票入帳' },
    { key: 3, label: '財務收支' },
    { key: 4, label: '帳戶互轉' },
    { key: 5, label: '零用現金出入帳' },
    { key: 6, label: '借款動撥、還款' },
    { key: 7, label: '人事薪資付款' },
];

export const accountYearStatus = [
    { key: 0, label: '進行中' },
    { key: 1, label: '結算作業中' },
    { key: 2, label: '已關帳' },
];
